import { trackAdImpression as snowplowTrackAdImpression } from '@snowplow/browser-plugin-ad-tracking';
import type { SelfDescribingJson } from '@snowplow/browser-tracker';

export interface TrackAdImpressionData {
  impressionId?: string;
  costModel?: 'cpa' | 'cpc' | 'cpm';
  cost?: number;
  targetUrl: string;
  bannerId?: string;
  impressionOrder: string;
  advertiserId: string;
  campaignId?: string;
}

/**
 * Track trackAdImpression event in Snowplow.
 * v.0.13.0;
 * @public
 *
 * @param trackAdImpressionData - Object that contains event properties described in the Ad impression tracking document
 * (see https://docs.snowplow.io/docs/collecting-data/collecting-from-own-applications/javascript-trackers/browser-tracker/browser-tracker-v3-reference/tracking-events/#trackadimpression ).
 *
 * @example
 * ```ts
 *
 * import {trackAdImpression} from '@hc-frontend/third-party-snowplow';
 *
 * trackAdImpression({
 *   impressionId: '67965967893',
 *   costModel: 'cpm', // 'cpa', 'cpc', or 'cpm'
 *   cost: 5.5,
 *   targetUrl: 'http://www.example.com',
 *   bannerId: '23',
 *   impressionOrder: '7',
 *   advertiserId: '201',
 *   campaignId: '12'
 * });
 * ```
 */
function trackAdImpression(
  trackAdImpressionData: TrackAdImpressionData,
  contexts?: Array<SelfDescribingJson> | null,
): void {
  const {
    impressionId,
    costModel,
    cost,
    targetUrl,
    bannerId,
    impressionOrder,
    advertiserId,
    campaignId,
  } = trackAdImpressionData;
  snowplowTrackAdImpression({
    impressionId,
    costModel,
    cost,
    targetUrl,
    bannerId,
    zoneId: impressionOrder,
    advertiserId,
    campaignId,
    context: contexts,
  });
}

export { trackAdImpression };
